// extracted by mini-css-extract-plugin
export default {"black":"#000","primary":"#49aada","orange":"#eb9412"};